import { render, staticRenderFns } from "./LoadingSpan.vue?vue&type=template&id=551761a1"
import script from "./LoadingSpan.vue?vue&type=script&lang=js"
export * from "./LoadingSpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports